import React from 'react';
import './Benefits.css';
import IsometricWhyChooseUs from './IsometricWhyChooseUs';

const Benefits = () => {
  return (
    <section className="benefits-section" id="benefits">
      <div className="section-header benefits-header">
        <h2 data-text="Why Choose Us?">Why Choose Us?</h2>
        <p className="benefits-description">
          Built for modern hotels and hospitality businesses: delivering 5-star guest stays, cutting daily expenses, boosting bookings, and simplifying operations.
        </p>
      </div>

      <div className="benefits-showcase-wrapper">
        <IsometricWhyChooseUs />
      </div>
    </section>
  );
};

export default Benefits;